import Vue from 'vue'
import Vuex from 'vuex'
//import router from '@/router'
import router from './router'

Vue.use(Vuex)

const axios = require('axios');

export default new Vuex.Store({
  state: {
   user: null,
   error: null,
   loading: false
  },
  mutations: {
		 setUser (state, payload) {
			state.user = payload
		  },
		  setError (state, payload) {
			state.error = payload
		  }, 
		  
		  setLoading (state, payload) {
			state.loading = payload
		}
  },
  actions: {
		 CheckandShowBooking ({commit}, payload) {
			commit('setLoading', true)
			axios.post('https://mmb.msa.airportdirecttravel.com/submitlogin', {
				BookingReference: payload.bookingreference,
				LastName: payload.LastName,
				DepartureDate: payload.DepartureDate
			  })
			  .then(function (response) {
				response = JSON.parse(response.request.response);
				if (response.error)
				{
					console.log(response.error);
					commit('setError', response.error)
					commit('setLoading', false)
				}
				else
				{
					commit('setUser', payload.bookingreference)
					localStorage.setItem("brefcl",payload.bookingreference)
					localStorage.setItem("brefcldata",JSON.stringify(response))
					console.log(response);
					commit('setLoading', false)
					router.push('/mybooking')
				}
			  })
			  .catch(function (error) {
				 console.log(error);
				 commit('setError', error.message)
				 commit('setLoading', false)
			  })
		  }	,	 
		  
		  SubmitSupport ({commit}, payload) {
			commit('setLoading', true)
			axios.post('https://mmb.msa.airportdirecttravel.com/contactsupport', {
				contactissuemessage: payload.contactissuemessage,
				selectedissuetype: payload.contactissuetype,
				bookingreference: payload.bookingreference
			  })
			  .then(function (response) {
				response = JSON.parse(response.request.response);
				if (response.error)
				{
					console.log(response.error);
					commit('setError', response.error)
					commit('setLoading', false)
				}
				else
				{
					commit('setLoading', false)
					
				}
			  })
			  .catch(function (error) {
				 console.log(error);
				 commit('setError', error.message)
				 commit('setLoading', false)
			  })
		  },
		  
		  SubmitAPIS ({commit}, payload) {
			commit('setLoading', true)
			axios.post('https://mmb.msa.airportdirecttravel.com/submitapis', {
				bookingreference: payload.bookingreference,				
				dateped: payload.dateped, 
				datepid: payload.datepid, 
				gender: payload.gender, 
				nationality: payload.nationality, 
				passport_number: payload.passport_number, 
				passport_issue_place: payload.passport_issue_place,
				DateOfBirth_ch: payload.DateOfBirth_ch
			  })
			  .then(function (response) {
				response = JSON.parse(response.request.response);
				if (response.error)
				{
					console.log(response.error);
					commit('setError', response.error)
					commit('setLoading', false)
				}
				else
				{
					commit('setLoading', false)
					router.push('/dashboard');
				}
			  })
			  .catch(function (error) {
				 console.log(error);
				 commit('setError', error.message)
				 commit('setLoading', false)
			  })
		  },

		  ResendConfirmation ({commit}, payload) {
			commit('setLoading', true)
			axios.get('https://mmb.msa.airportdirecttravel.com/sendmailfrommmb?BookingReference='+payload.bookingreference, {
				
			  })
			  .then(function (response) {
				response = JSON.parse(response.request.response);
				if (response.error)
				{
					console.log(response.error);
					commit('setError', response.error)
					commit('setLoading', false)
				}
				else
				{
					commit('setLoading', false)  
				}
			  })
			  .catch(function (error) {
				 console.log(error);
				 commit('setError', error.message)
				 commit('setLoading', false)
			  })   
		  }
  },
  getters: {
	  isAuthenticated (state) {
		return localStorage.getItem("brefcl") !== null
	  }
  }
})

			 

